export const ROLES_LIST = "ROLES_LIST";
export const ROLES_CREATE = "ROLES_CREATE";
export const ROLES_UPDATE = "ROLES_UPDATE";
export const ROLES_DELETE = "ROLES_DELETE";
export const ROLES_SHOW = "ROLES_SHOW";
export const ROLES_PERMISSIONS_LIST = "ROLES_PERMISSIONS_LIST";
export const ROLES_PERMISSIONS_UPDATE = "ROLES_PERMISSIONS_UPDATE";
export const ROLES_PERMISSIONS_DELETE = "ROLES_PERMISSIONS_DELETE";
